module.exports = __webpack_public_path__ + "img/star-05.fd1685ad.svg";